module.exports = __webpack_public_path__ + "static/media/005-drop.09b69bca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/CareIcons/005-drop.png
// module id = 155
// module chunks = 0